import { ICompactProduct } from "api/interfaces/get-page-details/common/CompactProduct.type";

export function getThumbmailSrc(product: ICompactProduct) {
  if (product.thumbnailV2) {
    return `${process.env.NEXT_PUBLIC_ROOT_URL}/img/cth/${product.thumbnailV2}`;
  }
  let imageURL = `${process.env.NEXT_PUBLIC_ROOT_URL}/images/common/image-not-available_16051144.png`;
  if (
    typeof product.thumbnail !== "undefined"
        && product.thumbnail !== null
  ) {
    imageURL = `${process.env.NEXT_PUBLIC_ROOT_URL}/${process.env.NEXT_PUBLIC_THUMBNAILS_IMAGE_PATH}/${product.thumbnail}`;
  } else if (
    typeof product.imagePaths !== "undefined"
        && product.imagePaths !== null
        && Array.isArray(product.imagePaths)
        && product.imagePaths.length > 0
  ) {
    imageURL = `${process.env.NEXT_PUBLIC_ROOT_URL}/${
            process.env.NEXT_PUBLIC_THUMBNAILS_IMAGE_PATH
        }/${product.imagePaths[0]}`;
  }
  return imageURL;
}

export function getThumbnailSrcV2(product: ICompactProduct) {
  if (!product.thumbnailV2) {
    return getThumbmailSrc(product);
  }
  const imagePath = product.thumbnailV2.replace(/^\//, "");
  return `${process.env.NEXT_PUBLIC_ROOT_URL}/img/cth/${imagePath}`;
}

export function getProductImageV2(product: ICompactProduct) {
  return product.thumbnailV2 ? `${process.env.NEXT_PUBLIC_ROOT_URL}/img/ds/${product.thumbnailV2}` : getThumbmailSrc(product);
}
